<!-- src/app/signature-pad/signature-pad.component.html -->
<div class="buscador fade-in-image traerAlFrente">
   <div class="row">
      <div class="col-lg-11"></div>
      <button (click)="cancelar();" type="button" class="btn col-lg-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/>
            </svg>
          </button>
  </div>
  <h2 class="text-center">{{titulo}}</h2>
  <br>
  <br>
   <div class="signature-container">
      <div class="canvas-container">
         <canvas #signatureCanvas class="signature-pad"></canvas>
      </div>
      <div class="controls">
         <button class="btn-danger" (click)="clearSignature()">Borrar</button>
         <button class="btn-success" (click)="saveSignature()">Guardar</button>
      </div>
   </div>
</div>